module.exports = __webpack_public_path__ + "img/fantomplay.64a6c8b2.svg";